/* SUMMARY
 * Functions for secure cookie management
 */

/**
 * Définit un cookie sécurisé
 * @param name - Nom du cookie
 * @param value - Valeur à stocker
 * @param expiryMinutes - Durée de validité en minutes (défaut: 60 minutes)
 */
export function setSecureCookie(name: string, value: string, expiryMinutes = 60): void {
  const date = new Date();
  date.setTime(date.getTime() + (expiryMinutes * 60 * 1000));
  
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Strict; Secure`;
}

/**
 * Récupère la valeur d'un cookie
 * @param name - Nom du cookie à récupérer
 * @returns Valeur du cookie ou null si non trouvé
 */
export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookiePart = parts.pop();
    if (cookiePart) {
      return cookiePart.split(";").shift() || null;
    }
  }
  return null;
}

/**
 * Expiration
 * @param name - Nom du cookie à supprimer
 */
export function removeCookie(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
} 